import { z } from 'zod';

import { ComponentDefinition } from '../../types/ComponentDefinition';
import { ComponentPayloadValidator, ComponentValidator } from '../Component';
import { AbstractPort, Port } from '../fields/AbstractPort';
import { AcGroundingConfiguration, DcGroundingConfiguration } from '../fields/GroundingConfiguration';
import { Resistance } from '../fields/Resistance';

const port = AbstractPort.extend({
    AC: Port.AC.extend({
        groundingConfiguration: AcGroundingConfiguration.validator,
    }).default({}),
    DC: Port.DC.extend({
        groundingConfiguration: DcGroundingConfiguration.validator,
    }).default({}),
    powerFlowDirection: Port.powerFlowDirection.literals.input,
    earthingImpedance: Resistance.validators.value,
}).default({});

const GroundingBase = z.object({
    type: z.literal('grounding').default('grounding'),
    electrical: z
        .object({
            ports: z.tuple([port]).default([undefined]),
        })
        .default({}),
});

export const GroundingValidator = ComponentValidator.merge(GroundingBase);
export const GroundingPayloadValidator = ComponentPayloadValidator.merge(GroundingBase);

export const GroundingDefinition: ComponentDefinition = {
    type: 'grounding',
    name: 'Grounding',
    plural: 'Groundings',
    indicator: 'GND',
    deprecated: true, // grounding is configured on a bus instead
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['input'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: GroundingValidator,
        payload: GroundingPayloadValidator,
    },
};

export type Grounding = z.infer<typeof GroundingValidator>;
export type GroundingPayload = z.infer<typeof GroundingPayloadValidator>;
